var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hy-card',[_c('div',{attrs:{"slot":"head"},slot:"head"},[_c('span',[_vm._v("222")])]),_c('div',[_vm._v("6666")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }